// extracted by mini-css-extract-plugin
export default {"table":"qtCveKT9rAZPD7FgpDHw","column":"_puPH5hR_6O1X8qVIAMO","placeHolderShimmer":"ExZrg15d2m4NqZA28Y9v"};